export const TableWatermark = () => (
	<div className="text-right text-lg text-#393534 text-gray font-bold">
		epsmomentum.com
	</div>
);
